import React from "react";
import "./style.css";

const AboutCard = ({ title, disc }) => {
  return (
    <div className="relative w-full flex flex-col items-center hover:scale-110 group duration-300 shadow-none hover:shadow-2xl rounded-xl">
      <section id="advertisers" className="advertisers-service-sec">
        <div className="">
          <div className="service-card">
            <p className="font-bold text-2xl">{title}</p>
            <p className="font-medium text-lg">{disc}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutCard;
